import React from 'react';
import Title from '../../title';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import { Grid, Button, Pagination } from 'semantic-ui-react';
import View from  './view';
import Permission from '../../../functions/permission';

class Machinesales extends React.Component {

  state = {
    load: false, orders: [], pageNumber: 0, totalPages: 50, boundaryRange: 1,
    siblingRange: 1, showEllipsis: true, showFirstAndLastNav: true,
    showPreviousAndNextNav: true, menuPermission: []
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    if (this.props.type == 'Invoice') {
      let menuPermission = Permission('machine-invoice', this.props.menus);
      if (menuPermission.view) {
        this.getorder(1);
      }
      this.setState({ menuPermission })
    }
    else {
      let menuPermission = Permission('machine-quotation', this.props.menus);
      if (menuPermission.view) {
        this.getorder(1);
      }
      this.setState({ menuPermission })
    }
    
  }

  handlePaginationChange = (e, { activePage }) => {
    this.getMachineCustomer(activePage);
  }

  getorder(page) {
    let context = this;
    this.setState({ load: true, message: 'getting Cuatomer!!!' })
    $.ajax({
      type: 'POST', data: { 'page': page },
      url: Server()+'machinesales/getorder.php',
      success: function(data) {
        try {
          let totalPages;
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) { totalPages = data[i].totalPages; }
          totalPages = Number(totalPages);
          totalPages = totalPages / 100;
          let roundOff = Math.round( totalPages );
          if (roundOff < totalPages) { roundOff++; }
          context.setState({ orders: data, totalPages: roundOff, pageNumber: page, load: false })
        } catch (e) {
          context.setState({ load: false })
        }
      },
      error: function(e) {
        context.setState({ load: false });
      }
    });
  }

  update(data) { this.setState({ orders: data }) }

  render() {
    return (
      <div>
        <Title title={'Machine '+this.props.type} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <div style={{padding: '2%'}}>
                <View data={this.state.orders} getorder={this.getorder.bind(this)}
                  update={this.update.bind(this)}
                  menuPermission={this.state.menuPermission} type={this.props.type} />
                <div align="right">
                  <Pagination activePage={this.state.pageNumber} boundaryRange={this.state.boundaryRange}
                    onPageChange={this.handlePaginationChange} siblingRange={this.state.siblingRange}
                    totalPages={this.state.totalPages}
                    ellipsisItem={this.state.showEllipsis ? undefined : null}
                    prevItem={this.state.showPreviousAndNextNav ? undefined : null}
                    nextItem={this.state.showPreviousAndNextNav ? undefined : null}
                  />
                </div>
              </div>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Machinesales;
